
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Croup(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Croup"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                Croup refers to <b>an infection of the upper airway</b>, which obstructs breathing and causes a characteristic barking cough. The cough and other signs and symptoms of croup are the result of swelling around the voice box (larynx), windpipe (trachea) and bronchial tubes (bronchi).
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Croup/1.png")} alt="Autism" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Cough:</b>
                                            <br />
                                            can be barking
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Respiratory:</b>
                                            <br />
                                            difficulty breathing, fast breathing, noisy breathing, shortness of breath, or wheezing
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Whole body:</b>
                                            <br />
                                            fatigue or fever
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Nasal:</b>
                                            <br />
                                            congestion or runny nose
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Speech:</b>
                                            <br />
                                            hoarseness or impaired voice
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common:</b>
                                            <br />
                                            agitation, drooling, phlegm, or sore throat
                                        </p>
                                    </li>
                                </ul>
                                <a className="links" href="https://en.wikipedia.org/wiki/Croup">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Croup;